import { Expose } from 'class-transformer';

export class ModelUnityDocument {
    @Expose()
    consentActive: boolean;

    @Expose()
    agreed: boolean;

    @Expose()
    consentId: string;

    @Expose()
    consentLanguage: string;

    @Expose()
    consentLanguageIsoCode: string;

    @Expose()
    consentLongName: string;

    @Expose()
    consentName: string;

    @Expose()
    consentVersion: string;

    @Expose()
    consentVersionDateTime: string;

    @Expose()
    consentContent: any;
}

export class ModelUnityDocuments {
    @Expose()
    documents: Array<ModelUnityDocument>;
}
